module.exports = __webpack_public_path__ + "static/media/Dual_5051.7deb1ff9.jpg";